import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "i18n"

// Material UI
import { makeStyles } from "@material-ui/core/styles"
import { Box, Grid, Typography, Divider } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
  divider: {
    backgroundColor: theme.palette.common.white
  },
  thickDivider: {
    backgroundColor: theme.palette.common.white,
    height: 3,
    width: "40%",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  }
}))

export default function WhyChooseItem({ name, points }) {
  const { t } = useTranslation()

  const classes = useStyles()

  return (
    <Grid container direction="column">
      <Grid item>
        <Box mb={4}>
          <Typography variant="h4">
            {t("Why choose")} {name}?
          </Typography>
          <Divider className={classes.thickDivider} />
        </Box>
      </Grid>
      <Grid item container spacing={4}>
        {points.map(value => (
          <Grid item xs={12} sm={6} key={value.heading}>
            <Grid container spacing={1}>
              <Grid item xs="auto">
                <img src="/store/assets/images/trophy.svg" alt="trophy" />
              </Grid>
              <Grid item xs>
                <Typography variant="h6">{value.heading}</Typography>
                <Divider className={classes.divider} />
                <Typography variant="body1">{value.description}</Typography>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Grid>
  )
}

WhyChooseItem.propTypes = {
  points: PropTypes.array,
  name: PropTypes.string.isRequired
}
WhyChooseItem.defaultProps = {
  points: []
}
